import { 
	selectAllExercises,
	getExerciseLibrary,
	getAdditionalExerciseData
} from '../state/exerciseLibrary'
import { useSelector, useDispatch } from 'react-redux'

export const useExerciseLibrary = ()=>{
	const exercises = useSelector(selectAllExercises)
	const libraryStatus = useSelector(state=>state.exerciseLibrary.status)
	const {
		status:filtersStatus,
		exerciseLevels,
		muscleGroups,
		equipment,
	} = useSelector(state=>state.exerciseLibrary.filters)
	const dispatch = useDispatch()
	if( libraryStatus === 'init' ){
		dispatch(getExerciseLibrary())
	}
	if( filtersStatus === 'init' ){
		dispatch(getAdditionalExerciseData())
	}
	return {
		exerciseLevels,
		libraryStatus,
		filtersStatus,
		muscleGroups,
		exercises,
		equipment
	}
}